import { useRoute } from '@react-navigation/native';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ALL_JOBS_ID, TABLE_NAMES } from '@v2/pages/common/constants/base.constants';
import { useTableTools } from '@v2/pages/common/hooks/useTableTools';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { selectJobsData } from '@reducers/details';
import { generateImageURL as generateImageURLThunk } from '@reducers/blobStorage';
import { parseRouteParamAsNumber } from '@helpers';

export const useManageProductionOrderJobsContent = () => {
  const jobs = useSelector(selectJobsData);
  const dispatch = useAppDispatch();

  const route = useRoute();
  const jobId = parseRouteParamAsNumber(route.params?.selectedProductionOperationId);
  const isAllJobsSelected = jobId === ALL_JOBS_ID;

  const tableTools = useTableTools(TABLE_NAMES.productionOrderJobs);

  const generateImageURL = useCallback(
    (params: Parameters<typeof generateImageURLThunk>[0]) => dispatch(generateImageURLThunk(params)),
    [dispatch],
  );

  return {
    jobs,
    isAllJobsSelected,
    tableTools,
    generateImageURL,
  };
};
